import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/biens", label: "Nos biens" },
  { to: "/vendre", label: "Vendre" },
  { to: "/acheter", label: "Acheter" },
  { to: "/programmes-neufs", label: "Programmes neufs" },
  { to: "/agence", label: "Notre agence" },
  { to: "/conseils", label: "Conseils" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-azur text-sand">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img
              src="/kemelia-logo.png"
              alt="Kemelia Estate — Agence Immobilière"
              className="w-28 rounded-2xl border border-white/10"
            />
            <p className="mt-6 max-w-sm font-light leading-relaxed text-sand/70">
              Votre partenaire immobilier sur la Côte d'Azur. Acheter, vendre, investir — avec proximité, expertise et sérénité.
            </p>
            <Link
              to="/vendre"
              data-testid="footer-cta-estimation"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-medium text-azur transition-colors duration-300 hover:bg-sand"
            >
              Estimer mon bien
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-sand/50">Navigation</h3>
            <ul className="mt-6 space-y-3">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="font-light text-sand/80 transition-colors hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-sand/50">Contact</h3>
            <ul className="mt-6 space-y-4 font-light text-sand/80">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <a href="tel:+33786058140" data-testid="footer-phone" className="transition-colors hover:text-gold">+33 7 86 05 81 40</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <a href="mailto:office@kemeliaestate.com" data-testid="footer-email" className="transition-colors hover:text-gold">office@kemeliaestate.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-gold" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Kemelia+Estate+C%C3%B4te+d%27Azur"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-address"
                  className="transition-colors hover:text-gold"
                >
                  Côte d'Azur, France
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={16} className="text-gold" />
                <a href="https://instagram.com/kemeliaestate" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="transition-colors hover:text-gold">@kemeliaestate</a>
              </li>
              <li className="flex items-center gap-3">
                <svg viewBox="0 0 448 512" className="h-4 w-4 fill-gold" aria-hidden="true">
                  <path d="M448 209.9a210.1 210.1 0 0 1-122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0L302 0a209.6 209.6 0 0 0 21.3 33.3A210.6 210.6 0 0 0 448 122.8z" />
                </svg>
                <a href="https://tiktok.com/@kemeliaestate" target="_blank" rel="noreferrer" data-testid="footer-tiktok" className="transition-colors hover:text-gold">@kemeliaestate</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs font-light text-sand/50 sm:flex-row">
          <span>© 2026 Kemelia Estate — Tous droits réservés</span>
          <span className="font-mono uppercase tracking-[0.2em]">Mentions légales · Confidentialité</span>
        </div>
      </div>
    </footer>
  );
}
